'use client';

import React from 'react';
import { useInView } from 'react-intersection-observer';

type RevealOnScrollProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  threshold?: number;
  once?: boolean;
};

export default function RevealOnScroll({
  children,
  className = '',
  delay = 0,
  threshold = 0.15,
  once = true,
}: RevealOnScrollProps) {
  const { ref, inView } = useInView({
    triggerOnce: once,
    threshold,
  });

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out motion-reduce:transform-none motion-reduce:transition-none ${className}`}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0px)' : 'translateY(28px)',
        filter: inView ? 'blur(0px)' : 'blur(6px)',
        transitionDelay: inView ? `${delay}ms` : '0ms',
      }}
    >
      {children}
    </div>
  );
}